import script from "./ServiceStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceStatus.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceStatus.vue?vue&type=style&index=0&id=0b8d2331&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8d2331"]])

export default __exports__